import { NotificationEnvelope, NotificationEvent } from '@tfs/notifications';

import { ToolImportJobType, ToolImportStatus } from './data-import.model';

// Defined locally rather than imported from `@tfs/tool-library-api` because the
// auto-generated DTO declares the field as `toolImportJobId` while the BE
// (`ToolImportJobProcessingHandlerBase.NotifyToolImportStatusChangedAsync`)
// actually emits `toolImportId`. Update if the OpenAPI spec is fixed.
export interface ToolImportJobStatusChangePayload {
  toolImportId: string;
  toolImportJobId?: string;
  importType?: ToolImportJobType;
  status: ToolImportStatus;
}

export type ToolImportJobStatusChangeEvent = NotificationEnvelope<
  'ToolImportStatusChanged' | 'ToolImportProgressUpdated',
  ToolImportJobStatusChangePayload
>;

export const isToolImportJobStatusChangeEvent = (
  event: NotificationEvent
): event is ToolImportJobStatusChangeEvent =>
  event.type === 'ToolImportStatusChanged' || event.type === 'ToolImportProgressUpdated';
